import request from '@/utils/request'

/**
 * 获取首页初始化数据（整合接口）
 * 包含：systemInfo, systemIcons, articleTypes, focusArticles
 */
export function getHomeInitData() {
    return request({
        url: '/home/initData',
        method: 'get',
        params: {}
    })
}

export function queryFocus() {
    return request({
        url: '/articleDetails/queryFocus',
        method: 'get',
        params: {}
    })
}

export function queryArticleList(page, pageSize, type, value) {
    return request({
        url: '/articleDetails/queryArticleList',
        method: 'get',
        params: {'page': page, 'pageSize': pageSize, "type": type, "value":value}
    })
}

// 以下接口已整合到 getHomeInitData，不再单独使用
// export function querySystemInfo() { ... }
// export function querySystemIconInfo() { ... }
// export function queryAllType() { ... }

export function queryArticleById(id) {
    return request({
        url: '/article/queryArticleById/' + id,
        method: 'get',
        params: {}
    })
}

export function queryIp(ip) {
    return request({
        url: '/ip/queryIp',
        method: 'get',
        params: {
            ip: ip
        }
    })
}

export function getIp() {
    return request({
        url: '/ip/getIp',
        method: 'get',
        params: {}
    })
}

export function queryFriendInfo() {
    return request({
        url: '/friend/queryFriendInfo',
        method: 'get',
        params: {}
    })
}
